import React from "react";
import { useMediaQuery } from "@mui/material";

const DeploymentSection = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");

  const styles = {
    container: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      justifyContent: isMobile ? "center" : "space-between",
      alignItems: "flex-start", // Align items to the top
      backgroundColor: "#E8E4E1",
      padding: isMobile ? "50px 20px" : "100px",
      paddingBottom: isMobile ?"auto":"40px",
      borderRadius: "10px",
    },
    heading: {
      color: "#2D669B",
      fontSize: isMobile ? "1.5rem" : "2rem",
      fontWeight: "600",
      marginBottom: "20px",
      textAlign: isMobile ? "center" : "left",
    },
    leftTextContainer: {
      flex: 1,
      display: "flex",
      alignItems: "flex-start", // Align the top of the text container
      justifyContent: isMobile ? "center" : "flex-start",
      marginBottom: isMobile ? "20px" : "0",
    },
    rightTextContainer: {
      width: isMobile ? "100%" : "45%",
      paddingLeft: isMobile ? "0" : "20px",
    },
    title: {
      fontSize: isMobile ? "30px" : "40px",
      background: "linear-gradient(90deg, #2D669B 0%, #0582CA 100%)",
      WebkitBackgroundClip: "text",
      backgroundClip: "text",
      color: "transparent",
      fontWeight: "bold",
      textAlign: isMobile ? "center" : "left",
      marginTop: isMobile ? "0" : "0", // Adjust this margin as needed for alignment
    },
    paragraph: {
      color: "#6D6D6D",
      fontSize: isMobile ? "0.875rem" : "1rem",
      lineHeight: "1.6",
      marginBottom: "20px",
      textAlign: "justify",
      minWidth: isMobile ? "auto" : "540px",
    },
  };

  return (
    <div style={styles.container}>
      {/* Left Section: New Title */}
      <div style={styles.leftTextContainer}>
        <h2 style={styles.title}>
          Redefining Digital Asset
          <br />
          Security and Trust
        </h2>
      </div>

      {/* Right Section: Paragraph */}
      <div style={styles.rightTextContainer}>
        <h2 style={styles.heading}>Idea Behind Tennet</h2>
        <p style={styles.paragraph}>
          At Tennet, we believe in building a future where digital assets are as
          secure and accessible. In an increasingly digitized world,
          institutions and businesses require a trusted partner to safeguard
          their assets and facilitate seamless transactions, that’s where we
          come in. Tennet was founded with the core principle of trust and
          innovation. By leveraging advanced technologies and a customer-first
          approach, we aim to unlock the full potential of digital assets for
          institutions worldwide.
        </p>
      </div>
    </div>
  );
};

export default DeploymentSection;
